import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core"
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import AirplayIcon from '@material-ui/icons/Airplay';

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'flex',
    color: 'white'
  },
  active: {
    display: 'flex',
    color: '#FFD75E'
  },
  icon: {
    marginRight: theme.spacing(2),
    width: 20,
    height: 20,
    color: 'white'
  },
}));

function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function IconBreadcrumbs({ linkName = "Header" }) {
  const classes = useStyles();

  return (
    
    <Breadcrumbs aria-label="breadcrumb" style={{
      marginTop: '20px',
      marginBottom: '20px',
      // fontSize: '1ุpx',
      color: 'white'
    }}>
     
      <Link color="inherit" href="/" to='/'  className={classes.link}>
        <AirplayIcon className={classes.icon} />
        หน้าหลัก
      </Link>

      <Typography color="inherit" href="/"  className={classes.active}>
        {/* <HomeIcon className={classes.icon} /> */}
      {linkName}
      </Typography>
    </Breadcrumbs>
  );
}